import Vue from 'vue';
import Router from 'vue-router';

import TimeAnalysis from '@/components/tabs/TimeAnalysis';
import VisitAnalysis from '@/components/tabs/VisitAnalysis';
import ImpressionAnalysis from '@/components/tabs/ImpressionAnalysis';
import CampaignOverview from '@/components/tabs/CampaignOverview';
import AudienceAnalysis from '@/components/tabs/AudienceAnalysis';
import SummaryInsights from '@/components/tabs/SummaryInsights';
import GeographicalAnalysis from '@/components/tabs/GeographicalAnalysis';

Vue.use(Router);

const router = new Router({
  routes: [
    { path: '/:report_name', name: 'campaign-overview', component: CampaignOverview },
    { path: '/:report_name/geo', name: 'geographical-analysis', component: GeographicalAnalysis },
    { path: '/:report_name/time', name: 'time-analysis', component: TimeAnalysis },
    { path: '/:report_name/visit', name: 'visit-analysis', component: VisitAnalysis },
    { path: '/:report_name/impression', name: 'impression-analysis', component: ImpressionAnalysis },
    { path: '/:report_name/audience', name: 'audience-analysis', component: AudienceAnalysis },
    { path: '/:report_name/summary', name: 'summary-insights', component: SummaryInsights }
  ],
  // linkActiveClass: "active", // active class for non-exact links.
  // linkExactActiveClass: "active" // active class for *exact* links.
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js